import { render, staticRenderFns } from "./Fabric.vue?vue&type=template&id=e1f4abac&scoped=true&"
import script from "./Fabric.vue?vue&type=script&lang=js&"
export * from "./Fabric.vue?vue&type=script&lang=js&"
import style0 from "./Fabric.vue?vue&type=style&index=0&id=e1f4abac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f4abac",
  null
  
)

export default component.exports